export default function DeviceInfo({userId}) {
    return (<>device</>);
}
